import React from 'react';
import styled from 'styled-components';
import { Spacing24 } from 'autogen/design-tokens/tokens';
import { Headline } from 'components/generic/typography';
import type { IHeadlineTranslations } from '../shared/types';

const StyledHeadline = styled(Headline)`
    margin-bottom: ${Spacing24};
`;

export default function Header({ headline }: IHeadlineTranslations) {
    return <StyledHeadline size="M">{headline}</StyledHeadline>;
}
